// Port of api/fuel/app/classes/model/hindex/type.php
import Model from 'offline/stream/model/base'
import DB from 'offline/db'

export default Model.extend({
	table: 'hindex_type',
	prefix: 'hindex',
	key: 'hindex_id',
	fields: {
		hindex_id: Model.SCHEMA_KEY,
		user_id: Model.SCHEMA_NUMBER,
		hindex_official: Model.SCHEMA_NUMBER,
		hindex_public: Model.SCHEMA_NUMBER,
		hindex_name: Model.SCHEMA_TEXT,
		hindex_slug: Model.SCHEMA_TEXT,
		hindex_description: Model.SCHEMA_TEXT,
		hindex_author: Model.SCHEMA_TEXT,
		hindex_filter: Model.SCHEMA_JSON,
		hindex_users: Model.SCHEMA_NUMBER
	},
	methods: {
		to_public: function() {
			return {
				id: +this.get_id(),
				name: this.get_name()
			}
		},
		to_json: function() {
			var trackedUsers = parseInt(DB.scalar(
				'SELECT COUNT(*) FROM hindex_track WHERE hindex_id = ? AND track_hindex > 0',
				[this.get_id()]
			), 10) || 0
			var users = trackedUsers
			if (!users && String(this.get_id()) !== '1') {
				users = parseInt(this.get_hindex_users(), 10) || 0
			}
			var filter = this.get_filter()
			if (filter && typeof filter === 'object' && !Array.isArray(filter) && !Object.keys(filter).length) {
				filter = []
			}
			return {
				id: String(this.get_id()),
				user: this.get_user_id() || 0,
				name: this.get_name(),
				description: this.get_description(),
				public: this.get_public() || 0,
				author: this.get_author(),
				slug: this.get_slug(),
				users: users,
				filter: filter || {}
			}
		}
	}
})
